import { useEffect } from 'react';
import CmpConsentsModal from 'src/components/CmpConsentsModal';
import useCmpConsents from 'src/hooks/useCmpConsents';
import { ModalType } from 'src/types/Modal';
import { OrderedModalHookType } from './types';
import withLoginUserModalPromise from './withLoginUserModalPromise';
const useCmpConsentsModal: OrderedModalHookType = modalPropsPromise => {
  const {
    cmpConsents
  } = useCmpConsents();
  useEffect(() => {
    if (cmpConsents !== undefined) {
      modalPropsPromise?.resolve(cmpConsents ? [{
        modalProps: {
          key: ModalType.CMP_CONSENTS,
          component: CmpConsentsModal
        }
      }] : null);
    }
  }, [cmpConsents, modalPropsPromise]);
};
export default withLoginUserModalPromise(useCmpConsentsModal);